import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  image: { width: 123, height: 75 },
  imageOnly: { width: 40, height: 40, marginRight: 20 },
});
